import { AngularFireDatabase, AngularFireList, AngularFireObject } from 'angularfire2/database';
import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { HomePage } from '../home/home';

@Component({
  selector: 'gamepin-home',
  templateUrl: 'gamePin.html'
})

export class gamePinPage {
  gamePin: string;
  gameId: number;
  errorMessage: string = "Skriv inn game pin";
  gameIdData: any;


  constructor(public navCtrl: NavController, public navParams: NavParams, private db: AngularFireDatabase){
    this.db.object('showInfo').query.once("value").then(data => {
      this.gameId = data.val().gameId;
    }).then(data => {
        this.db.object('show/' + this.gameId).query.once("value").then(data => {
          this.gameIdData = data.val();
        })
    })

  }

  enterGamePin(){

    this.db.object('show/' + this.gameId + '/gamepin').snapshotChanges().subscribe(action => {
      let liveShowId = action.payload.val()
      if (liveShowId.toString() === this.gamePin){
        this.navCtrl.setRoot(HomePage, {
          'gameId': this.gameId
        })
      } else {
        this.errorMessage = "Beklager, feil game pin"
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/gamePin/gamePin.ts